import { useState, useEffect, useContext } from "react";
import Context from "../../../context";

import { RemovePaymentTitle, RemovePaymentContent } from "./RemovePayment";
import { GasLeakContent, GasLeakTitle } from "./GasLeak";
import { MessageContent, MessageTitle } from "./Message";

const Modal = () => {
  const [modalBgShow, setModalBgShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const { contextState, setContextState } = useContext(Context);

  const modalData = {
    removePayment: {
      title: <RemovePaymentTitle />,
      content: <RemovePaymentContent />,
    },
    gasLeak: {
      title: <GasLeakTitle />,
      content: <GasLeakContent />,
    },
    message: {
      title: <MessageTitle />,
      content: <MessageContent />,
    },
  };

  const closeModal = () => {
    return setContextState((prevState) => ({ ...prevState, modal: null }));
  };

  const showClass = (bool) => {
    return bool ? " show" : "";
  };

  useEffect(() => {
    if (contextState.modal) {
      setModalBgShow(true);
      const timeShowModal = setTimeout(() => {
        setModalShow(true);
      }, 200);
      return () => clearTimeout(timeShowModal);
    } else {
      setModalShow(false);
      setModalBgShow(false);
    }
  }, [contextState.modal]);

  return (
    contextState.modal && (
      <>
        <div
          className={`modal-bg fade ${showClass(modalBgShow)}`}
          onClick={() => closeModal()}
        />
        <div
          className={`modal fade ${showClass(modalShow)}`}
          style={contextState.modal ? { display: "block" } : {}}
          tabIndex="-1"
          role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {modalData[contextState.modal?.type]?.title}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => closeModal()}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{whiteSpace: 'pre-line'}}>
                {modalData[contextState.modal?.type]?.content}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default Modal;
